<div class="edit-lead-container">
  <div class="lead-card">
    <h2 class="lead-title">Leads</h2>
    <div class="lead-number">{{ leadSocket.newLeads }}</div>
  </div>  
  <div *ngIf="isFormLoaded" class="statuses-and-call-container">
    <div class="stats-container">
      <div class="time-spent">
        <span>Time spent: {{ minutes }}:{{ seconds | number:'2.0' }}</span>
      </div>
      <div class="lead-attempts">
        <span class="label">Lead Attempts:</span>
        <span class="count">{{ totalCalls }}</span>
      </div>
      <button *ngIf="!isNewStatus()" class="skip-button" (click)="onSkip()">
        Skip
      </button>
    <div class="history-link" (click)="openHistoryModal()">Client Leads History</div>

    <!-- Modal content -->
<!-- History Modal -->
<div *ngIf="isHistoryModalOpen" class="modal">
  <div class="modal-content">
    <!-- Close Button on top -->
    <div class="close" (click)="closeHistoryModal()">Close</div>

    <h3>Client History</h3>

    <div *ngIf="leadHistory?.length; else noData">
      <div *ngFor="let lead of leadHistory" class="lead-row">
        <div class="lead-info">
          <span><strong>Ref:</strong> {{ lead.fbLeadReference }}</span>
          <span><strong>Status:</strong> {{ lead.status }}</span>
          <span><strong>Shop:</strong> {{ lead.shopName || 'N/A' }}</span>
          <span><strong>Date:</strong> {{ lead.creationDate }}</span>
        </div>
      </div>
    </div>

    <!-- No Data Message -->
    <ng-template #noData>
      <p>No history available.</p>
    </ng-template>
  </div>
</div>
    </div>

    <div class="dial-call-container">
      <button 
        type="button" 
        class="dial-button" 
        (click)="onDialCall()"
        *ngIf="!isCalling">
        <i class="pi pi-phone"></i> Dial Call
      </button>
      
      <button 
        type="button" 
        class="end-call-button" 
        (click)="onEndCall()"
        *ngIf="isCalling">
        <i class="pi pi-phone-slash"></i> End Call
      </button>
    </div>
  </div>
  <form *ngIf="leadForm" [formGroup]="leadForm">
    <div class="lead-wrapper">
    
        <h3>Lead Section</h3>
        <!-- <p>Lead reference : {{ lead?.fbLeadReference }}</p> -->
      
      <div class="lead-fields">
        <div class="p-field">
          <label for="reference">REFERENCE NUMBER</label>
          <input id="referenceNumber" type="text" formControlName="referenceNumber" class="p-inputtext p-inputtext-outline"  />
        </div>
        <div class="p-field">
          <label for="webMaster">Web Master</label>
          <input id="webMaster" type="text" formControlName="webMaster" class="p-inputtext p-inputtext-outline" readonly />
        </div>
        <div class="p-field">
          <label for="name">NAME</label>
          <input id="name" type="text" formControlName="name" class="p-inputtext p-inputtext-outline"  />
        </div>
        <div class="p-field">
          <label for="shopName">SHOP NAME</label>
          <input id="shopName" type="text" formControlName="shopName" class="p-inputtext p-inputtext-outline"  />
        </div>
        
        <div class="p-field">
          <label for="fullAddress">FULL ADDRESS</label>
          <input id="fullAddress" type="text" formControlName="fullAddress" class="p-inputtext p-inputtext-outline" />
        </div>
        <div class="p-field">
          <label for="country">COUNTRY</label>
          <input id="country" type="text" formControlName="country" class="p-inputtext p-inputtext-outline"  />
        </div>
        <div class="p-field">
          <label for="countrycode">COUNTRY CODE</label>
          <input id="countrycode" type="text" formControlName="countrycode" class="p-inputtext p-inputtext-outline"  />
        </div>
        <div class="p-field">
          <label for="province">PROVINCE</label>
          <select id="province" formControlName="province" class="p-inputtext p-inputtext-outline" (change)="onProvinceChange($event)">
            <option value="">Select Province</option>
            <option *ngFor="let province of supportedCities" [value]="province">{{ province }}</option>
          </select>
        </div>
        <div class="p-field">
          <label for="city">CITY</label>
          <select id="city" formControlName="city" class="p-inputtext p-inputtext-outline" (change)="onCitySelected($event.target.value)">
            <option value="">Select City</option>
            <option *ngFor="let city of filteredCities" [value]="city">{{ city }}</option>
          </select>
        </div>
        <div class="p-field">
          <label for="zipCode">ZIP CODE</label>
          <input id="zipCode" type="text" formControlName="zipCode" class="p-inputtext p-inputtext-outline" />
        </div>
        <div class="p-field">
          <label for="primaryPhoneNumber">PRIMARYPHONENUMBER</label>
          <input id="primaryPhoneNumber" type="text" formControlName="primaryPhoneNumber" class="p-inputtext p-inputtext-outline" />
        </div>
        <div class="p-field">
          <label for="secondaryPhoneNumber">SECONDARYPHONENUMBER</label>
          <input id="secondaryPhoneNumber" type="text" formControlName="secondaryPhoneNumber" class="p-inputtext p-inputtext-outline" />
        </div>
        <div class="p-field">
          <label for="upsell">UPSELL</label>
          <input id="upsell" type="text" [formControl]="leadForm.get('upsell')" class="p-inputtext p-inputtext-outline" />
        </div>
        <div class="p-field">
          <label for="scheduledDeliveryDate">SCHEDULED DELIVERY DATE</label>
          <input id="scheduledDeliveryDate" type="date" formControlName="scheduledDeliveryDate" class="p-inputtext p-inputtext-outline" />
        </div>
        
      </div>
    </div>

    <div class="offer-container">
      
        <h3>Offer Details</h3>
      
      <div class="offer-details">
        <div class="p-field">
          <label for="offerId">OFFER ID</label>
          <input id="offerId" type="text" formControlName="offerId" class="p-inputtext p-inputtext-outline" />
        </div>
        <div class="p-field">
          <label for="offerCurrency">OFFER CURRENCY</label>
          <input id="offerCurrency" type="text" formControlName="offerCurrency" class="p-inputtext p-inputtext-outline" />
        </div>
        <div class="p-field">
          <label for="offerValue">OFFRE VALUE</label>
          <input id="offerValue" type="text" formControlName="offerValue" class="p-inputtext p-inputtext-outline" />
        </div>
        <div class="p-field">
          <label for="offerUrl">OFFERURL</label>
          <input id="offerUrl" type="text" formControlName="offerUrl" class="p-inputtext p-inputtext-outline" [readonly]="true" />
        </div>
        <div class="p-field">
          <label for="allowedReducedPrice">ALLOWEDREDUCEDPRICE</label>
          <input id="allowedReducedPrice" type="text" formControlName="allowedReducedPrice" class="p-inputtext p-inputtext-outline" [readonly]="true" />
        </div>
      </div>
    </div>

        <!-- Products section -->
        <div formArrayName="products">
          <h3>Products Section</h3>
          <div *ngFor="let product of leadForm.get('products').controls; let i = index">
            <div [formGroup]="product" class="products">
              <div class="p-field">
                <label for="sku">SKU</label>
                <select id="skuSelect" formControlName="sku" (change)="onSkuSelect(i, $event.target.value)" class="p-inputtext p-inputtext-outline">
                  <option value="">Select SKU</option>
                  <option *ngFor="let sku of skusList; let last = last" [ngClass]="{'last-sku': last}" [value]="sku.sku">{{ sku.sku }}</option>
                </select>
              </div>
              <div class="p-field">
                <label for="quantity">Quantity</label>
                <input id="quantity" type="text" formControlName="quantity" class="p-inputtext p-inputtext-outline" />
              </div>
              <div class="p-field">
                <label for="value">Value</label>
                <input id="value" type="text" formControlName="value" class="p-inputtext p-inputtext-outline" />
              </div>
              <div class="p-field">
                <label for="currency">Currency</label>
                <input id="currency" type="text" formControlName="currency" class="p-inputtext p-inputtext-outline" />
              </div>
              <div class="p-field">
                <label for="description">Description</label>
                <textarea id="description" formControlName="description" class="p-inputtext p-inputtext-outline"></textarea>
              </div>
              <div class="p-field">
                <label for="productLink">Product Link</label>
                <input id="productLink" type="text" formControlName="productLink" class="p-inputtext p-inputtext-outline" />
              </div>
            </div>
            <div class="buttons-layout">
              <button type="button" (click)="removeProductConfirmation(i)" class="remove-button">Remove</button>
              <div *ngIf="showConfirmation && selectedIndex === i" class="confirm-layout">
                <app-delete-confirmation (confirm)="onDeleteConfirmation($event)"></app-delete-confirmation>
              </div>
            </div>
            <div class="responsive-line"></div>
          </div>
          <button type="button" (click)="addProduct()" class="add-product-btn">Add Product</button>
        </div>
     <!-- call center history table-->
     <div class="agent-container">
      <h3>Confirmation History</h3>
      <table class="confirmation-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Status</th>
            <th>Call Center Notes</th>
          </tr>
        </thead>
        <tbody *ngIf="lead?.confirmationHistory && lead.confirmationHistory.length > 0">
          <ng-container *ngFor="let confirmation of getDisplayedConfirmationHistory(); let i = index">
            <tr *ngIf="showAllRows || i < initialRowCount">
              <td>
                <ng-container *ngIf="confirmation.updatedAt">
                  <span class="date-label">Updated At:</span> {{ confirmation.updatedAt }}
                </ng-container>
                <ng-container *ngIf="confirmation.createdAt">
                  <span class="date-label" *ngIf="confirmation.updatedAt"> / </span>
                  <span class="date-label" *ngIf="!confirmation.updatedAt">Created At:</span> {{ confirmation.createdAt }}
                </ng-container>
              </td>
              <td>{{ confirmation.callCenterLeadStatus }}</td>
              <td>{{ confirmation.callCenterNote }}</td>
            </tr>
          </ng-container>
        </tbody>
        <tbody *ngIf="!(lead?.confirmationHistory && lead.confirmationHistory.length > 0)">
          <tr>
            <td colspan="3">No confirmation history available.</td>
          </tr>
        </tbody>
      </table>
      <button *ngIf="!showAllRows && lead?.confirmationHistory && lead.confirmationHistory.length > initialRowCount" (click)="toggleRowCount()" class="show-button">
        Show All
      </button>
      <button *ngIf="showAllRows" (click)="toggleRowCount()" class="show-button">
        Show Less
      </button>
    </div>
    
  
       <!-- Add input field for call center notes -->
       <div class="call-center-notes">
        <label for="callCenterNotes">Call Center Notes : </label>
        <textarea id="callCenterNotes" formControlName="callCenterNotes" class="p-inputtext p-inputtext-outline call-centernotes"></textarea>
      </div>
      
     
<div class="last-step">
  <div class="p-field status-field">
    <label for="status">Status</label>
    <select id="status" formControlName="status" class="p-inputtext p-inputtext-outline" (change)="onStatusChange($event)">
      <option *ngFor="let option of dropdownListStatus" [value]="option">{{ option }}</option>
    </select>
  </div>
  <div *ngIf="showCancellationReasons" class="p-field cancellation-reasons">
    <label for="cancellationReason">Cancellation Reason</label>
    <select id="cancellationReason" formControlName="cancellationReason" class="p-inputtext p-inputtext-outline">
      <option *ngFor="let reason of cancellationReasons" [value]="reason">{{ reason }}</option>
    </select>
  </div>
  <button type="button" (click)="onSubmit()" class="save-changes-btn" [disabled]="isSubmitting">Save Changes</button>
</div>
    
  </form>
</div>

<app-modal></app-modal>